var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterBlcak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8595 18.9377C10.6003 18.9377 10.3756 18.8427 10.1856 18.6526C9.99548 18.4625 9.90045 18.2374 9.90045 17.9773C9.90045 17.7171 9.99548 17.492 10.1856 17.3019C10.3756 17.1119 10.6003 17.0168 10.8595 17.0168H13.1403C13.3995 17.0168 13.6242 17.1119 13.8142 17.3019C14.0043 17.492 14.0993 17.7171 14.0993 17.9773C14.0993 18.2374 14.0043 18.4625 13.8142 18.6526C13.6242 18.8427 13.3995 18.9377 13.1403 18.9377H10.8595ZM2.46023 6.60744C2.20008 6.60744 1.97497 6.5076 1.7849 6.30793C1.59482 6.1073 1.49979 5.88699 1.49979 5.64699C1.49979 5.3878 1.59482 5.16317 1.7849 4.9731C1.97497 4.78302 2.20008 4.68799 2.46023 4.68799H21.5396C21.7997 4.68799 22.0248 4.78302 22.2149 4.9731C22.405 5.16317 22.5 5.3878 22.5 5.64699C22.5 5.88699 22.405 6.1073 22.2149 6.30793C22.0248 6.5076 21.7997 6.60744 21.5396 6.60744H2.46023ZM6.0601 12.7575C5.79995 12.7575 5.57484 12.6624 5.38477 12.4724C5.19469 12.2823 5.09966 12.0572 5.09966 11.797C5.09966 11.557 5.19469 11.3372 5.38477 11.1375C5.57484 10.9378 5.79995 10.838 6.0601 10.838H17.9699C18.2301 10.838 18.4552 10.9378 18.6453 11.1375C18.8344 11.3372 18.9289 11.557 18.9289 11.797C18.9289 12.0572 18.8344 12.2823 18.6453 12.4724C18.4552 12.6624 18.2301 12.7575 17.9699 12.7575H6.0601Z",
    fill: "#6D6D6D",
    stroke: "#6D6D6D",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlcak);
export default __webpack_public_path__ + "static/media/FilterBlcak.4eacb58536272b89f839b0a735a93079.svg";
export { ForwardRef as ReactComponent };